/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const getDisciplinaryActionByIdIdRegExpTwo = new RegExp('^-?(?:0|[1-9]\\d*)$');
export const getDisciplinaryActionByIdPayloadRegExpTwo = new RegExp('^-?(?:0|[1-9]\\d*)$');


export const GetDisciplinaryActionById = zod.object({
  "id": zod.union([zod.number(),zod.string().regex(getDisciplinaryActionByIdIdRegExpTwo)]).optional(),
  "payload": zod.union([zod.number(),zod.string().regex(getDisciplinaryActionByIdPayloadRegExpTwo)]).optional()
});

export type GetDisciplinaryActionById = zod.input<typeof GetDisciplinaryActionById>;
export type GetDisciplinaryActionByIdOutput = zod.output<typeof GetDisciplinaryActionById>;
